// SY07 공통코드 삭제 — 2.0 DELETE /api/v1/common-codes/{id} (LOGISPRD-9682, 물리삭제, 없으면 404).
// 행별로 순서대로 지운다. 실패하면 그 자리에서 멈추고, 앞서 지운 건수를 오류의 done 에 싣는다(저장과 같은 규약).
import { useMutation, type UseMutationResult } from '@tanstack/react-query'
import request from '@/utils/request'
import { inOrder } from '@/utils/inOrder'

export const useDeleteCommonCodes = (): UseMutationResult<number, Error, number[]> =>
  useMutation({
    mutationFn: (ids: number[]) => inOrder(ids, (id) => request.delete<ApiResponseV2<unknown>>('/api/v1/common-codes', id)),
  })
